import React, {useContext} from "react";
import Settings from "../../settings";
import useSWR from "swr";
import {CurrentPriceResponse, fetcher, isinUrl, REFRESH_TIME_LONG} from "../../widgets/data";
import {numberWithCommas} from "../../widgets/formatters";
import {format} from "date-fns/esm";

const SharePriceHeader = () => {
  const {getSetting} = useContext(Settings);

  const {data} = useSWR<CurrentPriceResponse>(
    isinUrl("price", getSetting("sharePriceGlobal.isin")),
    fetcher,
    {refreshInterval: REFRESH_TIME_LONG}
  );

  if (!data) return null;

  const fetched = data?.current.isoTimestamp
    ? new Date(data.current.isoTimestamp)
    : null;

  console.log(fetched)

  return (
    <div className={"share-price-header"}>
      <span className={"title"}>Share price:</span>
      <span className={"price__value"}>{numberWithCommas(data.current.close)}</span>
      <span className={"price__change__direction"}>
       <svg height="40" width="50" viewBox="0 0 50 40" className={data.change.direction}>
        <polygon
          points="25,1 1,39 49,39"
          className="triangle"
          style={{stroke: "none"}}
        />
      </svg>
      <span className={"price__change__value"}>{numberWithCommas(data.change.amount)}p</span>
      </span>
      <span className={"last-update"}>{" "}at {" "}
        {format(fetched, "dd/MM/yyyy")}
        {" "}
        {format(fetched, "HH:mm")}
      </span>
    </div>
  )
}

export default SharePriceHeader